import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Button } from '@/components/ui/button'
import { FileText, Loader2 } from 'lucide-react'

interface SynthesizerNodeDialogProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  content: string
  status?: string
  error?: string
}

export function SynthesizerNodeDialog({
  isOpen,
  onClose,
  title = 'Synthesized Content',
  content,
  status,
  error
}: SynthesizerNodeDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5" />
            {title}
          </DialogTitle>
          {error && (
            <DialogDescription className="text-red-500">
              {error}
            </DialogDescription>
          )}
        </DialogHeader>
        <ScrollArea className="flex-1 p-4 border rounded-lg">
          {status === 'processing' ? (
            <div className="flex items-center justify-center p-4">
              <Loader2 className="w-6 h-6 animate-spin" />
              <span className="ml-2">Processing content...</span>
            </div>
          ) : (
            <div className="whitespace-pre-wrap">{content}</div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
